(function () {
  const ZOOM = 2.4;
  const DRAG_THRESHOLD = 6;

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function getPanLimits(box, scale) {
    return {
      minX: -box.clientWidth * (scale - 1),
      maxX: 0,
      minY: -box.clientHeight * (scale - 1),
      maxY: 0,
    };
  }

  function applyTransform(img, scale, tx, ty) {
    img.style.transformOrigin = '0 0';
    img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
  }

  function resetZoom(slide, img) {
    if (!img) img = slide.querySelector('.product__media img');
    if (img) {
      img.style.transition = 'transform 0.25s ease';
      img.style.transform = '';
      img.style.willChange = '';
      img.style.opacity = '';
    }
    slide.querySelectorAll('.image-magnify-full-size').forEach(function (o) { o.remove(); });
    slide.classList.remove('is-zoomed');
    slide.dataset.zoomState = 'out';
    slide.dataset.tx = '0';
    slide.dataset.ty = '0';
    const box = slide.querySelector('.product__media');
    if (box) box.style.cursor = 'zoom-in';
  }

  function zoomIn(slide, img, box, clickX, clickY) {
    const rect = box.getBoundingClientRect();
    const cx = clickX - rect.left;
    const cy = clickY - rect.top;
    const limits = getPanLimits(box, ZOOM);
    const tx = clamp(-cx * (ZOOM - 1), limits.minX, limits.maxX);
    const ty = clamp(-cy * (ZOOM - 1), limits.minY, limits.maxY);
    img.style.willChange = 'transform';
    img.style.transition = 'transform 0.25s ease';
    applyTransform(img, ZOOM, tx, ty);
    slide.classList.add('is-zoomed');
    slide.dataset.zoomState = 'in';
    slide.dataset.tx = String(tx);
    slide.dataset.ty = String(ty);
    box.style.cursor = 'zoom-out';
    attachPanHandlers(slide, img, box);
  }

  function attachPanHandlers(slide, img, box) {
    if (slide.dataset.panInit === '1') return;
    slide.dataset.panInit = '1';

    let drag = null;

    function onDown(e) {
      if (slide.dataset.zoomState !== 'in') return;
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();
      drag = {
        startX: e.clientX,
        startY: e.clientY,
        origTx: parseFloat(slide.dataset.tx || '0'),
        origTy: parseFloat(slide.dataset.ty || '0'),
        moved: false,
        pointerId: e.pointerId,
      };
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
      img.style.transition = 'none';
    }

    function onMove(e) {
      if (!drag) return;
      const dx = e.clientX - drag.startX;
      const dy = e.clientY - drag.startY;
      if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) drag.moved = true;
      e.preventDefault();
      const limits = getPanLimits(box, ZOOM);
      const nx = clamp(drag.origTx + dx, limits.minX, limits.maxX);
      const ny = clamp(drag.origTy + dy, limits.minY, limits.maxY);
      applyTransform(img, ZOOM, nx, ny);
      slide.dataset.tx = String(nx);
      slide.dataset.ty = String(ny);
    }

    function onUp(e) {
      if (!drag) return;
      const wasMoved = drag.moved;
      try { box.releasePointerCapture(drag.pointerId); } catch (err) {}
      drag = null;
      img.style.transition = 'transform 0.25s ease';
      if (wasMoved) {
        slide.dataset.suppressClick = '1';
        setTimeout(function () { delete slide.dataset.suppressClick; }, 50);
      }
    }

    box.addEventListener('pointerdown', onDown);
    box.addEventListener('pointermove', onMove);
    box.addEventListener('pointerup', onUp);
    box.addEventListener('pointercancel', onUp);
  }

  function isImageSlide(slide) {
    if (!slide) return false;
    if (slide.querySelector('.deferred-media, video, model-viewer, iframe')) return false;
    const container = slide.querySelector('.product-media-container');
    if (container && !container.classList.contains('media-type-image')) return false;
    return true;
  }

  function attachClickHandler(box) {
    if (box.dataset.clickZoomInit === '1') return;
    box.dataset.clickZoomInit = '1';

    const slide = box.closest('.product__media-item');
    const img = box.querySelector('img');
    if (!slide || !img) return;
    if (!isImageSlide(slide)) return;

    img.onclick = null;
    img.classList.remove('image-magnify-hover', 'image-magnify-click');

    box.style.cursor = 'zoom-in';

    box.addEventListener('click', function (e) {
      if (slide.dataset.suppressClick === '1') return;
      e.preventDefault();
      e.stopPropagation();
      if (slide.dataset.zoomState === 'in') {
        resetZoom(slide, img);
      } else {
        zoomIn(slide, img, box, e.clientX, e.clientY);
      }
    });
  }

  function playVideoIn(deferred) {
    if (!deferred) return;
    if (!deferred.getAttribute('loaded')) {
      const tpl = deferred.querySelector('template');
      if (tpl) {
        const node = tpl.content.firstElementChild
          ? tpl.content.firstElementChild.cloneNode(true)
          : null;
        if (node) {
          if (node.tagName === 'VIDEO') {
            node.setAttribute('muted', '');
            node.setAttribute('playsinline', '');
            node.setAttribute('autoplay', '');
          }
          deferred.appendChild(node);
          deferred.setAttribute('loaded', 'true');
        }
      }
    }
    const v = deferred.querySelector('video');
    if (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      try {
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }
  }

  function switchActiveSlide(gallery, mediaId) {
    if (!gallery) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    const targetSlide = viewer.querySelector('[data-media-id="' + mediaId + '"]');
    if (!targetSlide) return;

    viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
      if (el !== targetSlide) {
        el.classList.remove('is-active');
        resetZoom(el);
      }
    });
    targetSlide.classList.add('is-active');

    const list = targetSlide.parentElement;
    if (list) {
      const left = targetSlide.offsetLeft;
      list.scrollLeft = left;
      requestAnimationFrame(function () {
        list.scrollLeft = targetSlide.offsetLeft;
      });
    }

    const deferred = targetSlide.querySelector('.deferred-media');
    if (deferred) {
      playVideoIn(deferred);
      setTimeout(function () { playVideoIn(deferred); }, 100);
    }

    const thumbsRoot = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbsRoot) {
      thumbsRoot.querySelectorAll('button').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      const activeThumb = thumbsRoot.querySelector('[data-target="' + mediaId + '"] button');
      if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
      const thumbsList = thumbsRoot.querySelector('[id^="Slider-Thumbnails"]');
      const activeThumbLi = thumbsRoot.querySelector('[data-target="' + mediaId + '"]');
      if (thumbsList && activeThumbLi) {
        thumbsList.scrollLeft = activeThumbLi.offsetLeft;
      }
    }
  }

  function attachThumbnailHandler(thumb) {
    if (thumb.dataset.thumbZoomInit === '1') return;
    thumb.dataset.thumbZoomInit = '1';

    const btn = thumb.querySelector('button');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const gallery = thumb.closest('media-gallery');
      const mediaId = thumb.dataset.target;
      if (!gallery || !mediaId) return;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        const viewer = gallery.querySelector('[id^="GalleryViewer"]');
        const targetSlide = viewer && viewer.querySelector('[data-media-id="' + mediaId + '"]');
        if (targetSlide && targetSlide.parentElement) {
          viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
            el.classList.toggle('is-active', el === targetSlide);
          });
          targetSlide.parentElement.scrollTo({ left: targetSlide.offsetLeft });
        }
      }
    });
  }

  function attachSlideChangedHandler(gallery) {
    if (gallery.dataset.slideChangedInit === '1') return;
    gallery.dataset.slideChangedInit = '1';

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    viewer.addEventListener('slideChanged', function (event) {
      const currentEl = event.detail && event.detail.currentElement;
      if (!currentEl) return;
      viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
        if (el !== currentEl) resetZoom(el);
      });
    });
  }

  function attachVideoSlideClick(slide) {
    if (slide.dataset.videoClickInit === '1') return;
    if (isImageSlide(slide)) return;
    slide.dataset.videoClickInit = '1';

    slide.addEventListener('click', function (e) {
      if (e.target.closest('video, iframe, model-viewer')) return;
      const mediaId = slide.dataset.mediaId;
      if (!mediaId) return;
      const gallery = slide.closest('media-gallery');
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      }
    });
  }

  function bootstrap() {
    document
      .querySelectorAll('.product__media-wrapper .product__media-item .product__media')
      .forEach(attachClickHandler);
    document
      .querySelectorAll('.product__media-wrapper .product__media-item')
      .forEach(attachVideoSlideClick);
    document
      .querySelectorAll('.product__media-wrapper .thumbnail-list__item[data-target]')
      .forEach(attachThumbnailHandler);
    document
      .querySelectorAll('.product__media-wrapper media-gallery')
      .forEach(attachSlideChangedHandler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', bootstrap);
})();